import React, { Component } from 'react';
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';
import Modal from './Modal';

const categoryBannerSpecs =  <p className='img-properties'>
									A lifestyle image with no text, offer codes, or logos. <br />
									<strong>Dimensions (pixels):</strong> 330 width x 480 height
									<br />
									<strong>Size:</strong> 50KB max
							</p>
							

const categoryPageImages = [
	{
		title: 'Accessories',
		imgURL: 'https://cdn.couponology.com/images/mediakit-accessories-category.jpg',
		alt: 'Accessories Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Accessories Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-accessories-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									This placement is an excellent opportunity to advertise your accessory related products. Created for the accessories category, this banner is purposed to engage with the most appropriate audience and generate great campaign results.
								</p>
								<p>
									The accessories banner is ideal for featuring sitewide or products offers. It ensures the highest performance in sales for every accessory related brand.
								</p>
							</div>
							{/*<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Testimonials:</h4>
								<q>
									Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
								</q>
							</div>*/}
						</div>
					  </SimpleBar>
	},
	{
		title: 'Arts and Crafts',
		imgURL: 'https://cdn.couponology.com/images/mediakit-art-category.jpg',
		alt: 'Arts and Crafts Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Arts and Crafts Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-art-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									This placement offers an excellent opportunity to advertise your arts and crafts related products.
								</p>
								<p>
									The Arts and Crafts category best suits companies that offer related arts and crafts or are a craft store. The offers for each available craft store are updated weekly so shoppers never miss out on an awesome deal. Each week, as placements change, there are always new promotions available.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Automotive',
		imgURL: 'https://cdn.couponology.com/images/mediakit-automotive-category.jpg',
		alt: 'Automotive Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Automotive Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-automotive-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									The automotive banner accomodates automotive related images. Higher conversion rates can be achieved with this banner, promoting your products and securing the highest engagement for all automotive related campaigns.
								</p>
								<p>
									Designed to target specific consumers with specific needs, this banner is the necessary placement for a successful campaign.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Baby',
		imgURL: 'https://cdn.couponology.com/images/mediakit-baby-category.jpg',
		alt: 'Baby Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Baby Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-baby-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									This placement offers an excellent opportunity to advertise your infant and baby related products.
								</p>
								<p>
									The Baby category best suits companies that offer products specific to this market. The offers for each available store are updated weekly so shoppers never miss out on a great deal. Each week, as placements change, new promotions are made available.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Beauty',
		imgURL: 'https://cdn.couponology.com/images/mediakit-beauty-category.jpg',
		alt: 'Beauty Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Beauty Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-beauty-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									This placement is an excellent opportunity to advertise your beauty related products. Choose the beauty banner for your campaign and target the right audience.
								</p>
								<p>
									Maximize your revenue, increase click through rates, and provide great advertising value. Feature your best online promos or sitewide offers and make your brand more familiar with a product or lifestyle image that will capture consumers' attention.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Bed and Bath',
		imgURL: 'https://cdn.couponology.com/images/mediakit-bed-category.jpg',
		alt: 'Bed and Bath Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Bed and Bath Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-bed-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									The Bed and Bath banner accomodates related product images. Higher conversion rates can be achieved with this banner, promoting your products and securing the highest engagement for all Bed and Bath related campaigns.
								</p>
								<p>
									Designed to target consumers with specific needs, this banner is the necessary placement for a successful campaign.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Books and Media',
		imgURL: 'https://cdn.couponology.com/images/mediakit-books-category.jpg',
		alt: 'Books and Media Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Books and Media Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-books-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									The books and media banner is a placement of significant value and a must-have for every book or media related campaign. Make this placement the main feature of your campaign in order to achieve higher performance and additional traffic with the best possible creative.
								</p>
								<p>
									This banner will allow you to target a more specific group of consumers with a product or lifestyle image that will, even more, familiarize our audience with your brand.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Costume',
		imgURL: 'https://cdn.couponology.com/images/mediakit-costume-category.jpg',
		alt: 'Costume Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Costume Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-costume-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									This placement is an excellent opportunity to advertise your costume related products. Choose the appropriate banner for your campaign and target the right audience.
								</p>
								<p>
									Maximize your revenue, increase click through rates, and provide great advertising value. Feature your best online promos or sitewide offers and make your brand more familiar with a product or lifestyle image that will capture consumers' attention.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Educational',
		imgURL: 'https://cdn.couponology.com/images/mediakit-education-category.jpg',
		alt: 'Educational Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Educational Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-education-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									The Educational banner is the perfect opportunity for your company to advertise your educational related products.
								</p>
								<p>
									Creatives that target to a certain audience are always essential for driving higher conversion rates and truly capture the attention of the consumer. This banner provides a great placement opportunity that should be a part of any educational or instructional related campaign.
								</p>
							</div>
						</div>
					  </SimpleBar>
	},
	{
		title: 'Electronics',
		imgURL: 'https://cdn.couponology.com/images/mediakit-electronics-category.jpg',
		alt: 'Electronics Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Electronics Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-electronics-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									This placement is an excellent opportunity to advertise your electronic products. Created for the electronics category, this banner is purposed to engage with the most appropriate audience and generate great campaign results.
								</p>
								<p>
									The electronics banner is ideal for featuring sitewide or products offers. It ensures the highest performance in sales for every electronics brand.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Events',
		imgURL: 'https://cdn.couponology.com/bannergallery/mediakit-womens-category.png',
		alt: 'Events Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Events Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-events-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
								 	The Events banner is the absolute best placement that focuses on the exposure of an event related brand to a targeted audience.
								</p>
								<p>
									If you want to promote events such us concerts, tournaments, entertainment shows or event related products, then your promotional campaign should include this banner in order to generate exceptional results and give a more visual experience to your audience.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Flowers',
		imgURL: 'https://cdn.couponology.com/images/mediakit-flowers-category.jpg',
		alt: 'Flowers Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Flowers Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-flowers-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									Opening a floral shop and waiting for consumers is not good enough for the growth of your business. Reach out to your customers with the best placement opportunity that focuses on the exposure of your product and brand to a targeted audience.
								</p>
								<p>
									Creatives that target to a certain audience are always essential for driving higher conversion rates and truly capture the attention of the consumer. This banner provides a great placement opportunity that should be a part of any floral related campaign.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Food and Drink',
		imgURL: 'https://cdn.couponology.com/images/mediakit-food-category.jpg',
		alt: 'Food and Drink Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Food and Drink Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-food-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									The Food and Drink banner is ideal for brands that want to promote food and drink related products. This placement will offer you great exposure with a lifestyle or product creative that draws attention to your campaign and brand.
								</p>
								<p>
									This banner serves to bring focus to your promotional campaign in order to secure higher conversion rates and excellent performance.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Gifts',
		imgURL: 'https://cdn.couponology.com/images/mediakit-gifts-category.jpg',
		alt: 'Gifts Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Gifts Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-gifts-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									Drive traffic, convert clicks, and bring attention to your brand with a banner placement designed to bring customers to your gift related site.
								</p>
								<p>
									Creatives that target to a certain audience are always essential for driving higher conversion rates and truly capture the attention of the consumer. This banner provides a great placement opportunity that should be a part of any gift related campaign.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Grocery',
		imgURL: 'https://cdn.couponology.com/images/mediakit-grocery-category.jpg',
		alt: 'Grocery Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Grocery Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-grocery-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									The Grocery banner can accommodate grocery related, lifestyle or product images and is the perfect opportunity for a successful campaign that wants to promote grocery offers.
								</p>
								<p>
								 	Advertise your brand using an appealing creative and drive additional traffic and conversions. A necessary placement that will offer you even greater exposure and truly captivate your targeted audience.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Health',
		imgURL: 'https://cdn.couponology.com/images/mediakit-health-category.jpg',
		alt: 'Health Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Health Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-health-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									The health category is one of our top verticals, this best suits companies that offer health related products. The weekly offers for each available health affiliated store on Couponology are updated weekly so shoppers never miss out on an awesome deal.
								</p>
								<p>
									Each week, as company placements change, there are always new promotions available to target your specific audience.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Home Decor',
		imgURL: 'https://cdn.couponology.com/images/mediakit-home-category.jpg',
		alt: 'Home Decor Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Home Decor Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-home-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									The main feature that you need in order to engage your high-value customers during your campaign is a home decor banner. This is the ideal placement for advertising home decor products or sitewide offers with a lifestyle or product image.
								</p>
								<p>
									This represents the perfect placement opportunity that will target a specific audience and will increase your revenues at an outstanding rate.
								</p>
							</div>
						</div>
					  </SimpleBar>
	},
	{
		title: 'Intimates',
		imgURL: 'https://cdn.couponology.com/images/mediakit-intimates-category.jpg',
		alt: 'Intimates Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Intimates Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-intimates-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									Best suited for companies offering intimate apparel to their customers, the intimates category is one of our top verticals.
								</p>
								<p>
									Each week, as company placements change, there are always new promotions available to target your specific audience. Captivate your target audience with an intimate apparel lifestyle banner.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Jewelry and Watches',
		imgURL: 'https://cdn.couponology.com/images/mediakit-jewelry-category.jpg',
		alt: 'Jewelry and Watches Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Jewelry and Watches Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-jewelry-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									Orchestrate a more visual experience for your customers with this fantastic placement opportunity. The jewelry and watches banner is exactly what every advertiser needs in order to promote jewelry products during a campaign that will drive guaranteed results.
								</p>
								<p>
									Just add the best possible creative with jewelry content in your campaign and achieve thriving results.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Kids Apparel',
		imgURL: 'https://cdn.couponology.com/images/mediakit-kids-category.jpg',
		alt: 'Kids Apparel Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Kids Apparel Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-kids-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									Promote the latest trends in kids apparel with a lifestyle banner image uniquely positioned to increase revenue and direct customers to your online store. 
								</p>
								<p>
									This represents the perfect placement opportunity that will target a specific audience and will increase your revenues at an outstanding rate.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Kitchen and Dining',
		imgURL: 'https://cdn.couponology.com/images/mediakit-kitchen-category.jpg',
		alt: 'Kitchen and Dining Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Kitchen and Dining Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-kitchen-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									The Kitchen and Dining banner is a wonderful choice for placement of your kitchen related campaign.
								</p>
								<p>
									Featuring a lifestyle or product image used for kitchen and dining category promotions can create a more appealing visual experience for your audience, grow your revenue with greater engagement and ultimately earn your customer's dedication. A must-have opportunity for your campaign needs.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Lifestyle',
		imgURL: 'https://cdn.couponology.com/images/mediakit-lifestyle-category.jpg',
		alt: 'Lifestyle Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Lifestyle Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-lifestyle-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									Improve the lives and well-being of your customers while, at the same time, improving your click through rates by providing captivating lifestyle images as part of your campaign.
								</p>
								<p>
									The offers for each available lifestyle affiliated store on Couponology are updated weekly so shoppers never miss out on a fantastic deal. Each week new promotions can drive additional customer traffic in your direction.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Maternity',
		imgURL: 'https://cdn.couponology.com/bannergallery/mediakit-womens-category.png',
		alt: 'Maternity Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Maternity Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-maternity-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									The maternity banner is a wonderful placement opportunity that should always attract attention during your maternity related campaigns.
								</p>
								<p>
									Offer your audience an eyecatcher; a lifestyle or product image they can relate to, and increase their satisfaction and trust, while your revenues grow substantially. An opportunity of this importance represents an opportunity for a successful campaign.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Mens Apparel',
		imgURL: 'https://cdn.couponology.com/images/mediakit-mens-category.jpg',
		alt: 'Mens Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Mens Apparel Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-mens-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									As one of our top performing verticals, the mens apparel category presents your company with a unique opportunity to create a winning campaign meant specifically to drive sales and increase revenue.
								</p>
								<p>
									As a top performing category, your banner and promotion is uniquely placed above the fold to generate the success your campaign deserves.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Motorcycle',
		imgURL: 'https://cdn.couponology.com/images/mediakit-motorcycle-category.jpg',
		alt: 'Motorcycle Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Motorcycle Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-motorcycle-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									Capture your audience with this fantastic placement opportunity. The motorcycle banner is the main placement needed for your motorcycle related campaign.
								</p>
								<p>
									A lifestyle or product image can successfully enhance customer experience and increase satisfaction and loyalty. Drive higher engagements and grow your revenues with this terrific feature.
								</p>
							</div>
						</div>
					  </SimpleBar>
	},
	{
		title: 'Office Supplies',
		imgURL: 'https://cdn.couponology.com/images/mediakit-office-category.jpg',
		alt: 'Office Supplies Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Office Supplies Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-office-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									Impress your audience with this fantastic placement opportunity. The office supplies banner is the main placement needed for your office supplies related campaign.
								</p>
								<p>
									A lifestyle or product image can successfully enhance customer experience and increase satisfaction and loyalty. Drive higher engagements and grow your revenues with this terrific feature.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Outdoor Living',
		imgURL: 'https://cdn.couponology.com/images/mediakit-outdoor-category.jpg',
		alt: 'Outdoor Living Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Outdoor Living Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-outdoor-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									Outdoor living campaigns can be extremely successful just by selecting this amazing placement opportunity offering great potential. An outdoor living image can be a powerful trigger mechanism for the eye and activate your audience the right way.
								</p>
								<p>
									This placement is designed to generate traffic and lead to thriving campaign results.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Party',
		imgURL: 'https://cdn.couponology.com/images/mediakit-party-category.jpg',
		alt: 'Party Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Party Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-party-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									The party category banner is a wonderful placement opportunity that should always attract attention during your party related campaigns.
								</p>
								<p>
									Offer your audience an eyecatcher; a lifestyle or product image they can relate to, and increase their satisfaction and trust, while your revenues grow substantially. This opportunity represents an opportunity for a successful party related campaign.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Pet',
		imgURL: 'https://cdn.couponology.com/images/mediakit-pet-category.jpg',
		alt: 'Pet Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Pet Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-pet-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									Increase your audience with the selection of the Pet banner category placement. This terrific placement opportunity will promote any pet related offers with an engaging lifestyle or product creative.
								</p>
								<p>
									This banner placement represents an impressive feature that can be included in your campaign and is meant to secure the highest engagement value while increasing your revenues considerably.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Plus Fashion',
		imgURL: 'https://cdn.couponology.com/images/mediakit-plus-category.jpg',
		alt: 'Plus Fashion Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Plus Fashion Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-plus-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									The plus fashion category banner is a wonderful placement opportunity that should always attract attention during your plus fashion related campaigns.
								</p>
								<p>
									Offer your audience an eyecatcher; a lifestyle or product image they can relate to, and increase their satisfaction and trust, while your revenues grow substantially. This opportunity represents an opportunity for a successful plus fashion related campaign.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Services',
		imgURL: 'https://cdn.couponology.com/images/mediakit-services-category.jpg',
		alt: 'Services Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Services Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-services-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									Provide an exceptional experience for your customers and be rewarded with their trust and loyalty by selecting a services banner placement suitable for any services related campaign.
								</p>
								<p>
									By providing a lifestyle or product image used for the services category promotion, this creative can successfully deliver higher conversion rates needed to grow your earnings.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Shoes',
		imgURL: 'https://cdn.couponology.com/images/mediakit-shoes-category.jpg',
		alt: 'Shoes Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Shoes Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-shoes-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									As one of our top performing verticals, the shoes category presents your company with a unique opportunity to create a winning campaign meant specifically to drive sales and increase revenue.
								</p>
								<p>
									As a top performing category, your banner and promotion is uniquely placed above the fold to generate the success your campaign deserves.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Smoke Shop',
		imgURL: 'https://cdn.couponology.com/images/mediakit-smoke-category.jpg',
		alt: 'Smoke Shop Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Smoke Shop Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-smoke-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									Every smoke shop related campaign is in need of a smoke shop banner that will be targeting a certain group of customers with the best possible creative.
								</p>
								<p>
									A lifestyle or product image used for smoke shop category promotions can serve to improve customer experience and increase their interactivity. The selection of this terrific opportunity will help you drive higher engagements.
								</p>
							</div>
						</div>
					  </SimpleBar>
	},
	{
		title: 'Sporting Goods',
		imgURL: 'https://cdn.couponology.com/images/mediakit-sporting-category.jpg',
		alt: 'Sporting Goods Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Sporting Goods Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-sporting-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									Sports are a popular pastime. So why not take advantage of this unique opportunity to create a winning campaign meant specifically to drive sales and increase revenue.
								</p>
								<p>
									Improve the customer experience and increase engagement with a banner and promotion that is uniquely placed above the fold to generate the success your campaign deserves.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Swimwear',
		imgURL: 'https://cdn.couponology.com/images/mediakit-swimwear-category.jpg',
		alt: 'Swimwear Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Swimwear Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-swimwear-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									This placement is an excellent opportunity to advertise your swimwear related products. Designed for the swimwear category, this banner is purposed to engage with the most appropriate audience and drive great campaign results.
								</p>
								<p>
									The swimwear banner is ideal for featuring sitewide or products offers. It can ensure the highest performance in sales for every swimwear related brand.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Tech',
		imgURL: 'https://cdn.couponology.com/images/mediakit-tech-category.jpg',
		alt: 'Tech Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Tech Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-tech-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									Drive traffic, convert clicks, and bring attention to your brand with a banner placement designed to bring customers to your tech related site.
								</p>
								<p>
									Creatives that target to a certain technical audience are always essential for driving higher conversion rates and truly capture the attention of the consumer. This banner provides a great placement opportunity that should be a part of any tech related campaign.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Tools and Hardware',
		imgURL: 'https://cdn.couponology.com/images/mediakit-tools-category.jpg',
		alt: 'Tools and Hardware Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Tools and Hardware Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-tools-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									Engage your audience with this wonderful placement opportunity. The tools and hardware banner is the ideal placement for your tools and hardware related campaigns.
								</p>
								<p>
									A lifestyle or product image can successfully enhance the customer experience and increase satisfaction and loyalty. Drive higher engagements and grow your revenues with this terrific feature.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Toys and Games',
		imgURL: 'https://cdn.couponology.com/images/mediakit-toys-category.jpg',
		alt: 'Toys and Games Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Toys and Games Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-toys-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									The toys and games category banner is a wonderful placement opportunity that should always attract attention during your toys and games related campaigns.
								</p>
								<p>
									Offer your audience an eyecatcher; a lifestyle or product image they can relate to, and increase their satisfaction and trust, while your revenues grow substantially. This opportunity represents an opportunity for a successful toys and games related campaign.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Travel',
		imgURL: 'https://cdn.couponology.com/images/mediakit-travel-category.jpg',
		alt: 'Travel Category',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Travel Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-travel-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									The travel banner is always an essential part of any travel related campaign. Choosing this amazing placement opportunity can help increase your revenues substantially and capture the attention of your audience with the use of a lifestyle or product image.
								</p>
								<p>
									Deliver a more visual experience to your customers and earn their loyalty.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Womens Apparel',
		imgURL: 'https://cdn.couponology.com/images/mediakit-women-category.jpg',
		alt: 'Womens Apparel',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Womens Apparel Category Banners</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-women-category-placement.jpg' alt='Category Placement' />
									{categoryBannerSpecs}
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									As one of our top performing verticals, the womens apparel category presents your company with a unique opportunity to create a winning campaign meant specifically to drive sales and increase revenue.
								</p>
								<p>
									As a top performing category, your banner and promotion is uniquely placed above the fold to generate the success your campaign deserves.
								</p>
							</div>
						</div>
					</SimpleBar>
	}
];

export default class Category extends Component {
	constructor(props) {
		super(props);
		this.state = { isModalOpen: false };
	  }
	
	  toggleModal = () => {
			this.setState({
				isModalOpen: !this.state.isModalOpen
			});
		}
		
		addModalContent = (modal_content) => {
			this.setState({
				modalContent: modal_content
			});
		}

	render() {
		return(
			<div className='row min-height-400 border component' id='category'>
				<div className='col-md-12 text-center'>
					<h2 className='section-heading'>160 Category Lifestyle Banners</h2>
					<ul className='sub-heading-list'>
						<li>
							<span>40 Unique Categories</span>
						</li>
						<li>
							<span className='glyphicon glyphicon-stop' aria-hidden='true'></span>
							<span>330x480 Top of Page Banners</span>
						</li>
						<li>
							<span className='glyphicon glyphicon-stop' aria-hidden='true'></span>
							<span>Captivating Lifestyle Images</span>
						</li>
					</ul>
				</div>
				{categoryPageImages.map((categoryPageImage, key) =>
					<div className='col-md-3 text-center' key={key}>
						<h3>{categoryPageImage.title}</h3>
						<div className='img-container'>
							<img src={categoryPageImage.imgURL} alt={categoryPageImage.alt} />
							<div className='overlay' />
							<div className='btn-container'>
								<button className='btn-1' onClick={() => {this.toggleModal(); this.addModalContent(categoryPageImage.modalContent);}}>See details</button>
							</div>
						</div>
					</div>
				)}

				{this.state.isModalOpen ? 
					<Modal
						text={this.state.modalContent}
						open={this.state.isModalOpen}
						onClose={this.toggleModal.bind(this)}
					/> : ''}
			</div>
		);
	}
}